import React from 'react';
import { VoucherPinNew as VoucherPinNewScreen } from '@features/voucher-new';

export const VoucherPinNew = (props: any) => <VoucherPinNewScreen {...props} />;
